import { render, staticRenderFns } from "./corporate-form.vue?vue&type=template&id=dcd36a6e"
import script from "./corporate-form.vue?vue&type=script&lang=js"
export * from "./corporate-form.vue?vue&type=script&lang=js"
import style0 from "./corporate-form.vue?vue&type=style&index=0&id=dcd36a6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports